import { PublicShell } from "@/components/site/PublicShell";
import { InstallSection } from "@/components/site/InstallSection";

export default function Install() {
  return (
    <PublicShell title="Download the EV-IDEX App" subtitle="Install EV-IDEX on Android, iPhone, iPad or desktop directly from this website — no app-store account required. You'll get the EV-IDEX icon on your home screen, a full-screen app and push alerts." wide>
      <div data-testid="install-page"><InstallSection compact /></div>
    </PublicShell>
  );
}
